import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import TID from "@/lib/testIds";

const stats = [
  { key: "projects", value: 100, suffix: "+", label: "Projects Completed" },
  { key: "satisfaction", value: 99, suffix: "%", label: "Client Satisfaction" },
  { key: "support", value: 24, suffix: "/7", label: "Support" },
  { key: "turnaround", value: 48, suffix: "h", label: "Fast Turnaround" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const dur = 1400;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(value * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref} className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">
      {n}
      <span className="text-gradient-brand">{suffix}</span>
    </span>
  );
};

export const Stats = () => {
  return (
    <section
      data-testid={TID.statsSection}
      className="relative py-12 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="rounded-3xl glass shadow-elevated px-6 py-10 md:px-12 md:py-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
            {stats.map((s, i) => (
              <motion.div
                key={s.key}
                data-testid={TID.statItem(s.key)}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.5 }}
                className="text-center md:text-left"
              >
                <Counter value={s.value} suffix={s.suffix} />
                <p className="mt-2 text-sm md:text-base text-slate-600 dark:text-slate-300 font-medium">
                  {s.label}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
